var createJournalController = require("../../util/journalControllerFactory") ;

module.exports = createJournalController({
    gridRoute: "dinvoice-payment-types",
    formRoute: "dinvoice-payment-type-form",
    importerRoute: "dinvoice-payment-type-importer",
}) ;
